// This file in the crypto folder for the import convenience.
import React, { Component } from "react";
import ether from "./../../../assets/images/Ethereum.svg";
import cobinhood from "./../../../assets/images/cobinhood.svg";
import wandx from "./../../../assets/images/wandx.svg";
import essentia from "./../../../assets/images/ess.svg";
import ncash from "./../../../assets/images/ncash.svg";
import xyo from "./../../../assets/images/xyo.svg";
import autonio from "./../../../assets/images/auto.svg";
import bitrewards from "./../../../assets/images/bit.svg";
import credits from "./../../../assets/images/credit.svg";
import stacs from "./../../../assets/images/stacs-logo.svg";
import singularitynet from "./../../../assets/images/singularity.svg";
import orbs from "./../../../assets/images/orbs-logo.svg";
import { VictoryPie } from "victory";
import DAOLevel from "./../functions/daolevel";
import { Link } from "react-router-dom";

export default class DashboardMainContent extends Component {
  render() {
    const precision = 4;
    var etherbalance = parseFloat(window.etherbalance).toFixed(5);
    var cobinhoodbalance = parseFloat(window.cobinhoodbalance).toFixed(precision);
    var wandxbalance = parseFloat(window.wandxbalance).toFixed(precision);
    var xyobalance = parseFloat(window.xyobalance).toFixed(precision);
    var ncashbalance = parseFloat(window.ncashbalance).toFixed(precision);
    var essentiabalance = parseFloat(window.essentiabalance).toFixed(precision);
    var singularitybalance = parseFloat(window.agibalance).toFixed(precision);
    var autoniobalance = parseFloat(window.autoniobalance).toFixed(precision);
    var bitrewardsbalance = parseFloat(window.bitrewardsbalance).toFixed(precision);
    var creditsbalance = parseFloat(window.creditsbalance).toFixed(precision);
    var stacsbalance = parseFloat(window.stacsbalance).toFixed(precision);
    const orbsbalance = parseFloat(window.orbsbalance).toFixed(precision);

    var ethprice = parseFloat(window.ethprice);
    var cobinhoodprice = parseFloat(window.cobinhoodprice);
    var wandxprice = parseFloat(window.wandxprice);
    var xyoprice = parseFloat(window.xyoprice);
    var ncashprice = parseFloat(window.ncashprice);
    var essentiaprice = parseFloat(window.essentiaprice);
    var singularityprice = parseFloat(window.agiprice);
    var autonioprice = parseFloat(window.autonioprice);
    var creditsprice = parseFloat(window.creditsprice);
    var bitrewardsprice = parseFloat(window.bitrewardsprice);
    var stacsprice = parseFloat(window.stacsprice);
    var orbsprice = parseFloat(window.orbsprice);
    var data = this.props.data;

    // var total = (
    //   cobinhoodbalance * cobinhoodprice +
    //   cybermilesbalance * cybermilesprice +
    //   wandxbalance * wandxprice +
    //   etherbalance * ethprice
    // ).toFixed(2);

    const sampledata = [
      { x: 1, y: etherbalance * ethprice },
      { x: 1, y: cobinhoodbalance * cobinhoodprice },
      { x: 1, y: wandxbalance * wandxprice },
      { x: 1, y: xyobalance * xyoprice },
      { x: 1, y: ncashbalance * ncashprice },
      { x: 1, y: essentiabalance * essentiaprice },
      { x: 1, y: singularitybalance * singularityprice },
      { x: 1, y: autoniobalance * autonioprice },
      { x: 1, y: bitrewardsbalance * bitrewardsprice },
      { x: 1, y: creditsbalance * creditsprice },
      { x: 1, y: stacsbalance * stacsprice },
      { x: 1, y: orbsbalance * orbsprice },
    ];

    console.log(sampledata);
    const colors = ["#6d76b5", "#19b491", "#156763", "#8e90c7", "#337AB7", "#678fffe3", "#40BCFF", "#3abbb9", "EF682D", "#dddddd", '#188ae2', '#cedff7ba'];

    //<p class="pull-right m-t-20 m-b-20" id="inline">{ethprice} USD</p>
    // <p>{data.dashboard_main_content.notification} </p>
    const kyc_level = window.kyc;
    const belongs  = window.belongs;
    if (kyc_level < 3 && belongs === 'Mr.Cho') {
      return (
        <div>
        <div class="row">
          <div class="col-md-12">
            <div class="card-box">
              <div class="widget-box-2">
                <div class="widget-detail-2 m-b-20 m-t-0 m-l-10 m-r-10">
                  <DAOLevel data={data.daolevel} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
        <div class="col-md-12">
        <div class="card-box">
          <div class="kyc-command">
          We require everyone to pass identification (KYC) in order to receive and withdraw airdrop tokens.
          Please do so before December 25, 2021.
          However, You do not need to pass KYC to send and receive ETH or AiDAO Token
          </div>
          <div class="kyc-command">
           에어드롭 토큰을 받고 출금하기 위해서는 모든 사람이 신분증(KYC)을 통과해야 합니다.
           2021년 12월 25일 이전에 해주세요.
           그러나 ETH 또는 AiDAO 토큰을 보내고 받기 위해 KYC를 통과할 필요가 없습니다.
           </div>

           <div class="kyc-command">
           If you have submitted KYC before but did not pass the KYC, you can now re-submit your documents.
           </div>
           <div class="kyc-command">
           이전에 KYC를 제출했지만 KYC를 통과하지 못한 경우 이제 문서를 다시 제출할 수 있습니다.
           </div>
           <Link  class="kyc-command" to={{ pathname: "/dashboard/account" }}>
             Go to Account Page to do KYC
           </Link>
           <Link  class="kyc-command" to={{ pathname: "/dashboard/account" }}>
             계정 페이지로 이동하여 KYC 수행
           </Link>
           </div>
           </div>
        </div>
        </div>
      )
    }

    return (
      <div>

        <div class="row">
          <div class="col-md-12">
            <div class="card-box">
              <div class="widget-box-2">
                <div class="widget-detail-2 m-b-20 m-t-0 m-l-10 m-r-10">
                  <p>Important Notification:
                  we are enforcing a fee upon airdrop token withdrawals.
                  You can check the fee for each token in the information page. </p>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="col-md-12">
            <div class="card-box">
              <div class="widget-box-2">
                <div class="widget-detail-2 m-b-20 m-t-0 m-l-10 m-r-10">
                  <DAOLevel data={data.daolevel} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-box">
          <div class="row">
            <div class="col-md-12 no-padding">
              <div class="widget-chart text-center">
                <div id="graphcontainer">
                  <VictoryPie
                    innerRadius={100}
                    style={{
                      labels: {
                        opacity: 0
                      }
                    }}
                    colorScale={colors}
                    data={sampledata}
                  />
                </div>

                <ul class="list-inline chart-detail-list m-b-0">
                  <li>
                    <h5 class="h5-class-1">
                      <i class="fa fa-circle m-r-5" />ETH
                    </h5>
                  </li>

                  <li>
                    <h5 class="h5-class-2">
                      <i class="fa fa-circle m-r-5" />COB
                    </h5>
                  </li>

                  <li>
                    <h5 class="h5-class-4">
                      <i class="fa fa-circle m-r-5" />WAND
                    </h5>
                  </li>
                  <li>
                    <h5 class="h5-class-6">
                      <i class="fa fa-circle m-r-5" />XYO
                    </h5>
                  </li>
                  <li>
                    <h5 class="h5-class-7">
                      <i class="fa fa-circle m-r-5" />NCASH
                    </h5>
                  </li>
                  <li>
                    <h5 class="h5-class-8">
                      <i class="fa fa-circle m-r-5" />ESS
                    </h5>
                  </li>
                  <li>
                    <h5 class="h5-class-9">
                      <i class="fa fa-circle m-r-5" />AGI
                    </h5>
                  </li>
                  <li>
                    <h5 class="h5-class-10">
                      <i class="fa fa-circle m-r-5" />NIO
                    </h5>
                  </li>

                  <li>
                    <h5 class="h5-class-11">
                      <i class="fa fa-circle m-r-5" />BIT
                    </h5>
                  </li>

                  <li>
                    <h5 class="h5-class-12">
                      <i class="fa fa-circle m-r-5" />CS
                    </h5>
                  </li>

                  <li>
                    <h5 class="h5-class-13">
                      <i class="fa fa-circle m-r-5" />STACS
                    </h5>
                  </li>

                  <li>
                    <h5 class="h5-class-14">
                      <i class="fa fa-circle m-r-5" />ORBS
                    </h5>
                  </li>

                </ul>
              </div>
            </div>
          </div>

          <div class="row m-t-20">
            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/ethereum" }}>
                <div class="widget-detail-2" id="ethereum">
                  <h5 class="m-b-0">Ethereum</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={ether} alt="ether icon" class="token32" />{" "}
                    {etherbalance} ETH
                  </h3>
                </div>
              </Link>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/cobinhood" }}>
                <div class="widget-detail-2" id="cobinhood">
                  <h5 class="m-b-0">Cobinhood</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={cobinhood} alt="cobinhood icon" class="token32" />{" "}
                    {cobinhoodbalance} COB
                  </h3>
                </div>
              </Link>
            </div>


            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/wandx" }}>
                <div class="widget-detail-2" id="wandx">
                  <h5 class="m-b-0">Wandx</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={wandx} alt="wandx icon" class="token32" />{" "}
                    {wandxbalance} WAND
                  </h3>
                </div>
              </Link>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/xyo" }}>
                <div class="widget-detail-2" id="xyo">
                  <h5 class="m-b-0">XYO</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={xyo} alt="xyo icon" class="token32" />{" "}
                    {xyobalance} XYO
                  </h3>
                </div>
              </Link>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/ncash" }}>
                <div class="widget-detail-2" id="ncash">
                  <h5 class="m-b-0">NCash</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={ncash} alt="ncash icon" class="token32" />{" "}
                    {ncashbalance} Ncash
                  </h3>
                </div>
              </Link>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/essentia" }}>
                <div class="widget-detail-2" id="essentia">
                  <h5 class="m-b-0">Essentia</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={essentia} alt="essentia icon" class="token32" />{" "}
                    {essentiabalance} ESS
                  </h3>
                </div>
              </Link>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/singularitynet" }}>
                <div class="widget-detail-2" id="singularitynet">
                  <h5 class="m-b-0">SingularityNet</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={singularitynet} alt="singularitynet icon" class="token32" />{" "}
                    {singularitybalance} AGI
                  </h3>
                </div>
              </Link>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/autonio" }}>
                <div class="widget-detail-2" id="autonio">
                  <h5 class="m-b-0">Autonio</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={autonio} alt="autonio icon" class="token32" />{" "}
                    {autoniobalance} NIO
                  </h3>
                </div>
              </Link>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/bitrewards" }}>
                <div class="widget-detail-2" id="bitrewards">
                  <h5 class="m-b-0">BitRewards</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={bitrewards} alt="bitrewards icon" class="token32" />{" "}
                    {bitrewardsbalance} BIT
                  </h3>
                </div>
              </Link>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/credits" }}>
                <div class="widget-detail-2" id="credits">
                  <h5 class="m-b-0">Credits</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={credits} alt="credits icon" class="token32" />{" "}
                    {creditsbalance} CS
                  </h3>
                </div>
              </Link>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/stacs" }}>
                <div class="widget-detail-2" id="stacs">
                  <h5 class="m-b-0">Stacs</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={stacs} alt="stacs icon" class="token32" />{" "}
                    {stacsbalance} STACS
                  </h3>
                </div>
              </Link>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <Link to={{ pathname: "/dashboard/orbs" }}>
                <div class="widget-detail-2" id="orbs">
                  <h5 class="m-b-0">Orbs</h5>
                  <div class="word-break m-b-0" />
                  <h3 class="token-account m-b-0" id="inline">
                    <img src={orbs} alt="orbs icon" class="token32" />{" "}
                    {orbsbalance} ORBS
                  </h3>
                </div>
              </Link>
            </div>

          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/cryptos/dashboard_main_content.js